import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { AudiogramSocialExportPlatform } from './AudiogramSocialExportPlatform';
export function AudiogramSocialExportAllPlatforms() {
  return (
    <div>
      {socialPlatforms.all().map((platform) => (
        <AudiogramSocialExportPlatform key={platform.id} platform={platform} />
      ))}
    </div>
  );
}
